"use client";
import { useAuth } from "@/contexts/AuthContext";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { sendGTMEvent } from "@next/third-parties/google";
import { useLocale } from "next-intl";
import Image from "next/image";
import { Button } from "./ui/Button";

export default function RegisterBanner() {
  const { isLogin, showLoginModal } = useAuth();
  const t = useTranslationDetector("common");
  const locale = useLocale();
  if (isLogin) {
    return null;
  }
  return (
    <div
      className={`relative flex h-[353px] w-full flex-col items-start justify-between overflow-hidden rounded-lg bg-[linear-gradient(357deg,rgba(245,245,249,0)_16.64%,#F5F5F9_101.04%),linear-gradient(93deg,#F5F5F9_16.43%,rgba(245,245,249,0)_80.86%),url('/images/dummy/register-mobile.png')] bg-cover bg-bottom bg-no-repeat p-6 text-left md:h-[400px] md:flex-row md:items-center md:p-0 lg:bg-[linear-gradient(87deg,#F5F5F9_41.17%,rgba(245,245,249,0)_87.64%)]`}
    >
      <div className="z-10 flex h-full w-full flex-col items-start justify-between md:p-10 md:pr-0 lg:gap-10 lg:p-15 lg:pr-0">
        {" "}
        <div className="flex flex-col gap-6">
          <h2 className="text-base-custom text-foreground m-0 font-semibold lg:text-4xl">
            {t("registerBannerTitle")}
          </h2>
          <ul className="m-o items-left flex flex-col justify-center gap-4 p-0">
            <li className="flex flex-row items-center justify-start gap-1">
              <FontAwesomeIcon
                className="h-6 w-6"
                icon={byPrefixAndName.far["circle-check"]}
              />
              <p className="text-foreground text-lg">
                {t("registerBannerBenefit1")}
              </p>
            </li>
            <li className="flex flex-row items-center justify-start gap-1">
              <FontAwesomeIcon
                className="h-6 w-6"
                icon={byPrefixAndName.far["circle-check"]}
              />
              <p className="text-foreground text-lg">
                {t("registerBannerBenefit2")}
              </p>
            </li>
            <li className="flex flex-row items-center justify-start gap-1">
              <FontAwesomeIcon
                className="h-6 w-6"
                icon={byPrefixAndName.far["circle-check"]}
              />
              <p className="text-foreground text-lg">
                {t("registerBannerBenefit3")}
              </p>
            </li>
          </ul>
        </div>
        <Button
          className="flex h-[50px] flex-row items-center gap-2"
          onClick={() => {
            sendGTMEvent({
              event: "custom_event",
              event_category: "click",
              event_action: "cta_click",
              cta_button: "sign_up_free",
              cta_location: "body",
              cta_category: "sign_up_dont_miss_opportunity",
              cta_language: locale.toUpperCase(),
            });
            showLoginModal();
          }}
        >
          <span className="text-base lg:text-lg">{t("registerBannerCta")}</span>
          <FontAwesomeIcon
            className="h-6 w-6"
            icon={byPrefixAndName.far["arrow-right"]}
          />
        </Button>
      </div>
      <div className="relative z-0 hidden h-full w-full lg:flex">
        <Image
          src="/images/dummy/registerbanner-new.png"
          alt="registerbanner-image"
          fill
          className="bg-[linear-gradient(87deg,#F5F5F9_41.17%,rgba(245,245,249,0)_87.64%)] object-cover"
        />
      </div>
    </div>
  );
}
